import { Component } from '@angular/core';

export interface FieldType {
  type: string;
  label: string;
  icon: string;
  description: string;
}

// Global variable to track the currently dragged field type
export let currentDraggedFieldType: FieldType | null = null;

@Component({
  selector: 'lib-field-palette',
  templateUrl: './field-palette.component.html',
  styleUrls: ['./field-palette.component.scss'],
})
export class FieldPaletteComponent {
  readonly fieldTypes: FieldType[] = [
    {
      type: 'text',
      label: 'FORM_BUILDER.FIELD_TYPES.TEXT',
      icon: 'text_fields',
      description: 'FORM_BUILDER.FIELD_TYPES.TEXT_DESC',
    },
    {
      type: 'textarea',
      label: 'FORM_BUILDER.FIELD_TYPES.TEXTAREA',
      icon: 'notes',
      description: 'FORM_BUILDER.FIELD_TYPES.TEXTAREA_DESC',
    },
    {
      type: 'number',
      label: 'FORM_BUILDER.FIELD_TYPES.NUMBER',
      icon: 'pin',
      description: 'FORM_BUILDER.FIELD_TYPES.NUMBER_DESC',
    },
    {
      type: 'date',
      label: 'FORM_BUILDER.FIELD_TYPES.DATE',
      icon: 'calendar_today',
      description: 'FORM_BUILDER.FIELD_TYPES.DATE_DESC',
    },
    {
      type: 'time',
      label: 'FORM_BUILDER.FIELD_TYPES.TIME',
      icon: 'schedule',
      description: 'FORM_BUILDER.FIELD_TYPES.TIME_DESC',
    },
    {
      type: 'select',
      label: 'FORM_BUILDER.FIELD_TYPES.SELECT',
      icon: 'arrow_drop_down_circle',
      description: 'FORM_BUILDER.FIELD_TYPES.SELECT_DESC',
    },
    {
      type: 'checkbox',
      label: 'FORM_BUILDER.FIELD_TYPES.CHECKBOX',
      icon: 'check_box',
      description: 'FORM_BUILDER.FIELD_TYPES.CHECKBOX_DESC',
    },
    {
      type: 'photo',
      label: 'FORM_BUILDER.FIELD_TYPES.PHOTO',
      icon: 'photo_camera',
      description: 'FORM_BUILDER.FIELD_TYPES.PHOTO_DESC',
    },
    {
      type: 'signature',
      label: 'FORM_BUILDER.FIELD_TYPES.SIGNATURE',
      icon: 'draw',
      description: 'FORM_BUILDER.FIELD_TYPES.SIGNATURE_DESC',
    },
    {
      type: 'divider',
      label: 'FORM_BUILDER.FIELD_TYPES.DIVIDER',
      icon: 'horizontal_rule',
      description: 'FORM_BUILDER.FIELD_TYPES.DIVIDER_DESC',
    },
  ];

  onDragStart(event: DragEvent, fieldType: FieldType): void {
    currentDraggedFieldType = fieldType;
    event.dataTransfer?.setData('text/plain', JSON.stringify(fieldType));
    event.dataTransfer!.effectAllowed = 'copy';
  }

  onDragEnd(event: DragEvent): void {
    currentDraggedFieldType = null;
  }
}
